import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export function useMarketDataRefresher() {
  const { toast } = useToast();

  useEffect(() => {
    let cancelled = false;

    const checkAndRefresh = async () => {
      try {
        const { data } = await supabase
          .from('dusk_market_data')
          .select('timestamp')
          .order('timestamp', { ascending: false })
          .limit(1)
          .single();

        const lastTs = data?.timestamp ? new Date(data.timestamp as unknown as string).getTime() : 0;
        const ageMs = Date.now() - lastTs;
        const oneHour = 60 * 60 * 1000;

        if (ageMs > oneHour) {
          const started = Date.now();
          const { error } = await supabase.functions.invoke('fetch-dusk-market-data');
          if (error) throw error;
          if (!cancelled) {
            toast({
              title: 'Market data refreshed',
              description: `Fetched latest DUSK price in ${(Date.now() - started)}ms`,
            });
          }
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Market data refresh failed:', err);
          toast({
            title: 'Failed to refresh market data',
            description: 'Will use last known price.',
            variant: 'destructive',
          });
        }
      }
    };

    checkAndRefresh();
    const interval = setInterval(checkAndRefresh, 60 * 60 * 1000); // check hourly

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [toast]);
}
